export default __webpack_public_path__ + "784f885d9fd2bce68d54b7a0e46b1c66.svg";